import { useContext, useEffect, useState } from "react";
import { api, dataProvider } from "data";
import { apiMethods } from "data/api.constants";
import { creator_miscellaneous_data_types } from "features/Common/modules/CreatorData/CreatorData.constants";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { logError } from "utils/error";
import { notification_color_keys, useNotifications } from "utils/hooks";
import { is_empty } from "utils/validations";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import { isRequestSuccessful } from "utils/Utils";

export const useCustomFooterToggle = () => {
  const { miscellaneous_data, fetchMiscellaneousData, set_miscellaneous_data } =
    useContext(WebpageCreationContext) ?? {};
  const { notify } = useNotifications();

  const customFooterRecord = miscellaneous_data?.customFooter?.[0];

  const [value, setValue] = useState(false);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    setValue(customFooterRecord?.data?.hide_footer === true);
  }, [miscellaneous_data?.customFooter]);

  const getFooterData = (hideFooter) => ({
    left_section: customFooterRecord?.data?.left_section ?? [],
    right_section: customFooterRecord?.data?.right_section ?? [],
    hide_footer: hideFooter,
  });

  const handleChange = async (checked) => {
    if (processing) return;

    const prevValue = customFooterRecord?.data?.hide_footer === true;
    setProcessing(true);
    setValue(checked);

    const nextData = getFooterData(checked);

    try {
      const isExistingRecord = !is_empty(customFooterRecord?.uuid);
      const apiResource = isExistingRecord
        ? api.creator_miscellaneous_data.update
        : api.creator_miscellaneous_data.create;
      const payload = isExistingRecord
        ? {
            uuid: customFooterRecord.uuid,
            updated_values: { data: nextData },
          }
        : {
            type: creator_miscellaneous_data_types.CUSTOM_FOOTER,
            data: nextData,
          };

      const status = await dataProvider.custom_request(
        apiResource,
        apiMethods.POST,
        payload
      );

      if (isRequestSuccessful(status.status)) {
        if (isExistingRecord) {
          set_miscellaneous_data({
            ...miscellaneous_data,
            customFooter: [
              {
                ...customFooterRecord,
                data: nextData,
              },
            ],
          });
        } else {
          fetchMiscellaneousData({
            type: creator_miscellaneous_data_types.CUSTOM_FOOTER,
          });
        }
      } else {
        setValue(prevValue);
      }
      notify(status?.message);
    } catch (error) {
      setValue(prevValue);
      logError({
        error,
        when: "handleChange",
        occuredAt:
          "src/features/ManageWebpage/modules/Customizations/modules/CustomFooter/hooks/useCustomFooterToggle.js",
      });
      notify(
        error?.body?.message ?? SOMETHING_WENT_WRONG,
        notification_color_keys.error
      );
    } finally {
      setProcessing(false);
    }
  };

  return {
    value,
    handleChange,
    processing,
  };
};
